import { NumberSymbol } from "@angular/common";

export class Base {
}

export interface IBase {
  id: string,
  created_at? : string,
}

export interface IAuditBaseDto {
  createdBy: string;
  CreatedOn: Date;
  LastModifiedBy: string;
  LastModifiedOn: Date;
}

export interface IBaseResponse {
  statusCode:ApiReturnType,
}

export enum ApiReturnType
{
    ValidationNeeded = 210,
    NotFound = 404,
    Ok = 200,
    Error = 500,
    Exception = 501,
    Data = 201
}

export interface IBaseSearchRequest {
  keyword? : string;
  pageNumber: number;
  pageSize: number;
  orderBy?: string[];
  advancedFilter?: IFilter,
  advancedSearch?: ISearch
}

export interface IFilter {
  logic?: "and" | "or" | "xor",
  filters?: IFilter[]
  field?: string,
  operator?: "eq" | "neq" | "lt" | "lte" | "gt" | "gte" | "startswith" | "endswith" | "contains",
  value?: string | boolean | number | Object,
}


export interface ISearch{
  fields: string[],
  keyword: string
}

export interface IPagedResults<T> {
  data: T;
  currentPage: number;
  totalPages: number;
  totalCount: number;
  pageSize: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface IGridResult<T> {
  data: T;
  total: number;
}

export interface IGridState {
  pageSize: number;
  skip: number;
}

export enum PageSize {
  Small = 25,
  Medium = 50,
  Large = 100,
}